export enum PartnersTabsEnum {
  GENERAL = 'general',
  CONTRACT = 'contract-partners'
}
